/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { CloseIcon, UserIcon } from 'assets/icons';
import { Input, Select } from 'components';
import { Globals } from 'utils';
import { GeneralService, UsersService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalEditDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

const ModalEditDoctor = ({ user, onClose }: ModalEditDoctorProps) => {

  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const [phoneCodes, setPhoneCodes] = useState<any[]>([]);
  const [form, setForm] = useState({
    user_id: '',
    photo: '',
    name: '',
    lastname: '',
    document_type_id: '',
    document: '',
    phonecode_id: '',
    phone: '',
    birthdate: '',
    email: '',
    hasFile: true,
  });

  const onChange = (value: string | File, target: keyof typeof form) => {
    setForm({ ...form, [target]: value });
  }

  const getSelects = () => {
    Promise.all([
      GeneralService.getDocumentTypes(),
      GeneralService.getPhoneCodes(),
    ])
      .then((res: any[]) => {
        setDocumentTypes(res[0].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
        setPhoneCodes(res[1].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
      })
      .catch(console.log);
  }

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.name)
      return Globals.showError('Debe ingresar el nombre');

    if (!form.lastname)
      return Globals.showError('Debe ingresar el apellido');

    if (!form.document_type_id)
      return Globals.showError('Debe ingresar el tipo de documento');

    if (!form.document)
      return Globals.showError('Debe ingresar la cédula de identidad');

    if (!form.birthdate)
      return Globals.showError('Debe ingresar la fecha de nacimiento');

    if (!form.phone)
      return Globals.showError('Debe ingresar el teléfono');

    if (!form.email)
      return Globals.showError('Debe ingresar el correo');

    onSubmit();
  }

  const onSubmit = async () => {
    try {
      await UsersService.updatePatient(form);
      Globals.showSuccess('Datos actualizados');
      onClose(true);

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  useEffect(() => {
    getSelects();
    setForm({
      user_id: user?.id,
      photo: user?.photo,
      name: user?.name,
      lastname: user?.lastname,
      document_type_id: user?.document_type_id,
      document: user?.document,
      phonecode_id: user?.phonecode_id,
      phone: user?.phone,
      birthdate: user?.birthdate,
      email: user?.email,
      hasFile: true,
    });
  }, []);

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">Editar</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="head">
        <div className="user-photo">
          {form.photo ? (
            <img src={Globals.fromStorage(form.photo)} alt="Usuario" />
          ) : (
            <img className="user-icon" src={UserIcon} alt="Usuario" />
          )}
        </div>
      </section>

      <section className="body">
        <Input
          label="Nombres"
          value={form.name}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'name')}
        />
        <Input
          label="Apellidos"
          value={form.lastname}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'lastname')}
        />
        <div className="document-group">
          <Select
            label="C.I."
            name="document_type_id"
            placeholder=" "
            value={form.document_type_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'document_type_id')}
            options={documentTypes}
          />
          <Input
            value={form.document}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'document')}
          />
        </div>
        <Input
          type="date"
          label="Fecha de nacimiento"
          value={form.birthdate}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'birthdate')}
        />
        <div className="phone-group">
          <Select
            label="Teléfono"
            name="phonecode_id"
            placeholder=" "
            value={form.phonecode_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phonecode_id')}
            options={phoneCodes}
          />
          <Input
            value={form.phone}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phone')}
          />
        </div>
        <Input
          label="Correo"
          value={form.email}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'email')}
        />
      </section>

      <div className="actions">
        <button>Guardar</button>
      </div>
    </form>
  );
}

export default ModalEditDoctor;